<!-- Inner Banner Start-->
<section class="inner-hero-banner">
  <div class="inner-hero-text">
    <h1 i18n [innerHTML]="'enliiigne.ContactUs' | translate"></h1>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#" i18n [innerHTML]="'enliiigne.Home' | translate"></a>
        </li>
        <li
          class="breadcrumb-item active"
          aria-current="page"
          i18n
          [innerHTML]="'enliiigne.ContactUs' | translate"
        ></li>
      </ol>
    </nav>
  </div>
</section>
<!-- Inner Banner End -->
<!-- Start Contact Area -->
<section class="contact-info" id="contact">
  <div class="list-inline-wrapper p-top-80 p-bottom-50">
    <div class="container">
      <div class="row">
        <div class="col-lg-4 col-md-6 col-sm-6">
          <div
            class="d-flex align-items-center justify-content-center contact-info-box"
          >
            <div class="icon">
              <span><i class="mdi mdi-phone-in-talk"></i></span>
            </div>
            <div class="contents">
              <h6>+1 514 209-7837</h6>
              <span class="sub-text">8am - 8pm</span>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6">
          <div
            class="d-flex align-items-center justify-content-center contact-info-box"
          >
            <div class="icon">
              <span><i class="mdi mdi-telegram"></i></span>
            </div>
            <div class="contents">
              <h6>enliiigne@gmail.com</h6>
              <span
                class="sub-text"
                i18n
                [innerHTML]="'enliiigne.FreeEnquity' | translate"
              ></span>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-12">
          <div
            class="d-flex align-items-center justify-content-center contact-info-box"
          >
            <div class="icon">
              <span><i class="mdi mdi-map-marker"></i></span>
            </div>
            <div class="contents">
              <h6 i18n [innerHTML]="'enliiigne.OfficeName' | translate"></h6>
              <span
                class="sub-text"
                i18n
                [innerHTML]="'enliiigne.OfficeAddress' | translate"
              ></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- End Contact Area -->
<!-- Start Get-In-Touch Area -->
<!--<section class="section getin-touch">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-md-6 col-sm-12">
        <h4 i18n>Let's Get In Touch</h4>
        <div
          class="contact_form wow fadeInUp"
          data-wow-delay="0.2s"
          data-wow-duration="1s"
        >
          <form>

          <div class="row">
                <div class="col-lg-12">
                <div class="form-group">
                  <input name="name" id="name" type="text" class="form-control" placeholder="Enter name..." required>
                </div>
              </div>

              <div class="col-lg-12">
                <div class="form-group">
                  <input name="email" id="email" type="email" class="form-control" placeholder="Enter email..." required>
                </div>
              </div>
              
              <div class="col-lg-12">
                <div class="form-group">
                  <input name="phone" id="phone" type="text" class="form-control" placeholder="Your Phone Number..." required>
                </div>
              </div>
              
              <div class="col-lg-12">
                <div class="form-group">
                  <textarea name="comments" id="comments" rows="4" class="form-control" placeholder="Your message..." required></textarea>
                </div>
              </div>
                         
              <div class="col-lg-12">
                <div class="d-flex justify-content-start">
                  <button action="mailto:mariyazin2701@gmail.com" method="post" enctype="text/plain" type="submit" class="btn btn-sm theme-btn text-white text-uppercase send-btn" i18n>Send Message</button>
                </div>
              </div>
               
            </div>

          </form> -->
<!-- <form action="mailto:mariyazin2701@gmail.com" method="post" enctype="text/plain">
            Name:<br>
            <input type="text" name="name"><br>
            E-mail:<br>
            <input type="text" name="mail"><br>
            Comment:<br>
            <input type="text" name="comment" size="50"><br><br>
            <input type="submit" value="Send">
            <input type="reset" value="Reset">
            </form> 
          <a href="mailto:enliiigne@gmail.com"
            ><div class="col-lg-12">
              <div class="d-flex justify-content-start">
                <button
                  class="btn btn-sm theme-btn text-white text-uppercase send-btn"
                  i18n
                >
                  Send E-mail
                </button>
              </div>
            </div></a
          >
        </div>
      </div>
    </div>
  </div>
</section>-->
<!-- End Get-In-Touch Area -->
